import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApplicationDashboardComponent } from './application-dashboard.component';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { AccordianComponent } from '@app/shared/custom-component/accordian/accordian.component';
import { GridActionsComponent } from '@app/shared/custom-component/grid-actions/grid-actions.component';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [ApplicationDashboardComponent],
  imports: [
    CommonModule, 
    FormsModule, 
    MatButtonModule, 
    MatIconModule,
    MatDialogModule,
    MatTooltipModule,
    DataGridComponent,
    AccordianComponent,
    GridActionsComponent
  ],
  exports: [ApplicationDashboardComponent]
})
export class ApplicationDashboardModule {}